module.exports = __webpack_public_path__ + "img/carte-blanche.c2441e2d.png";